import { getLocalizedStrings } from '../dashboardLocalizedStrings';
import SceButton from '../Common/customButton';
import classes from '../Common/errorCard.scss';

export default class ErrorCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            click: 0,
            refreshButtonImg: drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/refresh.svg',
        };
    }
    onclick = () => {
        let events = { alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:this.props.cardName, search:false};
        app.analyticsService.addPageLevelData('eventCapturing', events);
        window.aUtils ? window.aUtils.sendAAEvent("button", `dashboard|none|none|${this.props.cardName}|page|refresh`) : null; 
        this.props.fetchAccountDetails();
        this.setState({ click: this.state.click + 1 });
    }
    handleRefreshButtonHoverIn = () => {
        this.setState({ refreshButtonImg: drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/whiteRefresh.svg'});
    }

    handleRefreshButtonHoverOut = () => {
        this.setState({ refreshButtonImg: drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/refresh.svg'});
    }
    componentDidMount() {
        app.appService.setSessionstorage('errorMsg', this.props.errorMsg);
        app.appService.setSessionstorage('errorCard', this.props.cardName);
    }
    render() {
        const strings = getLocalizedStrings('errorMsg');
        let warningImg = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_warning.svg';
        return (
            <div id='dashBoardErrorCard' className={'row ' + classes.errorContainer + ''}>
                <div style={{marginTop:"20px"}} id={`error_${this.props.cardNameId}`} name={this.props.cardName}>
                    <img className={classes.errContWarImg} src={warningImg} alt="Warning Image" />
                    <p className={classes.errContWarMsg}> {this.props.errorMsg} </p>
                    <div style={{marginTop:"20px"}}> <SceButton handleRefreshButtonOver={this.handleRefreshButtonHoverIn} handleRefreshButtonOut={this.handleRefreshButtonHoverOut} buttonType={this.state.click === 2 ? 'sceErrorDisabled' : 'sceError'} value={strings.refresh} src={this.state.refreshButtonImg}  alt='refresh Icon' onClick={this.onclick} isDisabled={this.state.click === 2 ? true : false} /> </div>
                </div>
            </div>
        );
    }
}